import {NgModule} from '@angular/core';
import {defineCustomElements} from '@accman-shared/myselogerpro-web-components/loader';

import {MwcSidebar, MwcTabbar} from '../myselogerpro-web-components/src/directives/proxies';

defineCustomElements(window);

const DECLARATIONS = [
  // proxies
  MwcSidebar,
  MwcTabbar,
];

@NgModule({
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
  imports: [],
  providers: [],
})
export class MyselogerproWebComponentsModule {}
